import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

import { Alphabet } from "design-system/resources/html/components/glossary/alphabet/alphabet";
import Guides from "design-system/resources/html/components/common/guides/guides";
import ResponsiveTable from "design-system/resources/html/components/common/responsive-table/responsive-table";
// import LivePricesContract from "design-system/resources/html/components/contract-specifications/live-prices-contract/live-prices-contract";
// import MarginCalculator from "design-system/resources/html/components/margin-calculator/margin-calculator";
import Registartion from "design-system/resources/html/components/common/registration/registration";
import Header from "design-system/resources/html/components/common/header/header";
import NavbarMobile from "design-system/resources/html/components/common/navbar-mobile/navbar-mobile";
import Table from "design-system/resources/html/components/platforms/table/table";
import CompareAccounts from "design-system/resources/html/components/account-overview/compare-accounts/compare-accounts";
import Tabs from "design-system/resources/html/components/faq/tabs/tabs";
import DepositsTabs from "design-system/resources/html/components/deposits/deposits-tabs/deposits-tabs";
//import CarouselAutoSlide from "design-system/resources/assets/js/carouselAutoSlide";

import PhotoGalleryCarousel from "design-system/resources/html/components/photo-gallery-carousel/photo-gallery-carousel";
import { BackToTop } from "design-system/resources/html/components/glossary/back-to-top/back-to-top";
import RiskWarningBar from "design-system/resources/html/components/common/risk-warning-bar/risk-warning-bar";
import CardScroll from "design-system/resources/html/components/common/card-list/card-scroll";

import getIdCarouselForAutoSlide from "./carousel";
import getIdCarouselForGlideSlide from './glide';
// import messengerSet from "design-system/resources/html/components/common/messengers/messengers";
import setupLanguageSwitcher from './language-switcher';

const tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
tooltipTriggerList.forEach(function (tooltipTriggerEl) {
  new Tooltip(tooltipTriggerEl);
});

window.onload = function () {  
  getIdCarouselForAutoSlide();
  setupLanguageSwitcher();
  Guides();
  BackToTop();
  Tabs();
  Alphabet();  
  ResponsiveTable();
  // LivePricesContract();
  // MarginCalculator();
  Registartion();
  Header();
  NavbarMobile();
  Table();
  CompareAccounts();
  DepositsTabs();
  PhotoGalleryCarousel();
  RiskWarningBar();
  CardScroll();
  getIdCarouselForGlideSlide();
  // messengerSet();
};
